import React from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import Loader from '@domain-group/fe-co-loader';
import GoogleMapReact from './google-map-react';
import AllhomesMapStyle from './allhomes-map-style';
import * as styles from './allhomes-map.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var dummyEventHandler = () => {};
var AllhomesMap = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'allhomes-map' : _ref$className,
    coords = _ref.coords,
    googleMapsParams = _ref.googleMapsParams,
    _ref$zoom = _ref.zoom,
    zoom = _ref$zoom === void 0 ? 12 : _ref$zoom,
    icon = _ref.icon,
    _ref$marker = _ref.marker,
    marker = _ref$marker === void 0 ? 'exact' : _ref$marker,
    circle = _ref.circle,
    _ref$overrideOptions = _ref.overrideOptions,
    overrideOptions = _ref$overrideOptions === void 0 ? {} : _ref$overrideOptions,
    _ref$useBrandedStyles = _ref.useBrandedStyles,
    useBrandedStyles = _ref$useBrandedStyles === void 0 ? true : _ref$useBrandedStyles,
    _ref$onMapCreated = _ref.onMapCreated,
    onMapCreated = _ref$onMapCreated === void 0 ? dummyEventHandler : _ref$onMapCreated,
    _ref$onBoundsChanged = _ref.onBoundsChanged,
    onBoundsChanged = _ref$onBoundsChanged === void 0 ? dummyEventHandler : _ref$onBoundsChanged,
    _ref$onMarkerClick = _ref.onMarkerClick,
    onMarkerClick = _ref$onMarkerClick === void 0 ? dummyEventHandler : _ref$onMarkerClick,
    _ref$onMapClick = _ref.onMapClick,
    onMapClick = _ref$onMapClick === void 0 ? dummyEventHandler : _ref$onMapClick,
    _ref$onDragEnd = _ref.onDragEnd,
    onDragEnd = _ref$onDragEnd === void 0 ? dummyEventHandler : _ref$onDragEnd,
    _ref$onZoomChanged = _ref.onZoomChanged,
    onZoomChanged = _ref$onZoomChanged === void 0 ? dummyEventHandler : _ref$onZoomChanged,
    _ref$onMapTypeIdChang = _ref.onMapTypeIdChanged,
    onMapTypeIdChanged = _ref$onMapTypeIdChang === void 0 ? dummyEventHandler : _ref$onMapTypeIdChang,
    _ref$onRightClick = _ref.onRightClick,
    onRightClick = _ref$onRightClick === void 0 ? dummyEventHandler : _ref$onRightClick,
    _ref$onExpandMapClick = _ref.onExpandMapClick,
    onExpandMapClick = _ref$onExpandMapClick === void 0 ? dummyEventHandler : _ref$onExpandMapClick;
  var render = status => {
    switch (status) {
      case Status.LOADING:
      case Status.FAILURE:
        return ___EmotionJSX("div", {
          css: styles.map
        }, ___EmotionJSX(Loader, null));
      case Status.SUCCESS:
        return ___EmotionJSX(GoogleMapReact, {
          css: styles.map,
          center: coords,
          zoom: zoom,
          styles: useBrandedStyles ? AllhomesMapStyle : undefined,
          icon: icon,
          exactMarker: marker === 'exact',
          circle: circle,
          overrideOptions: overrideOptions,
          eventListeners: {
            onMapCreated,
            onBoundsChanged,
            onMarkerClick,
            onMapClick,
            onDragEnd,
            onZoomChanged,
            onMapTypeIdChanged,
            onRightClick,
            onExpandMapClick
          }
        });
      default:
    }
    return ___EmotionJSX("div", {
      css: styles.map
    });
  };
  return ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX(Wrapper, {
    apiKey: googleMapsParams.key,
    render: render
  }));
};
export default AllhomesMap;